module.exports = __webpack_public_path__ + "static/media/S20-0967_F_C_Hompage_2396x1473_EN.964d7f12.jpg";